import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { DocumentStatusEnum } from '@app/enums/document-status.enum';

export class FillingScore2850 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(
            mortgage._documents.filter((d) => d._template.groupId === 20 && !d.isArchived).length &&
            mortgage._documents
                .filter((d) => d._template.groupId === 20 && !d.isArchived)
                .every((d) =>
                    [DocumentStatusEnum.approved, DocumentStatusEnum.done, DocumentStatusEnum.sendOriginals].includes(
                        d.status
                    )
                )
        );
    }
}
